/*
 * Shorthand plugin that can be declared on links (onClick) or on tags (onReady) to log pageViews to the analytic API (no JS code needed).
 * There are basically two major cases:
 *
 * 1) An element rendered with the data-ga-analytic="<META Base64 String>"
 * 2) Any Ajax request that response contains the "Ga-Meta" Tag.
 */

import { registerModule } from "@/Registry";
import { renderJsonWithNumbersAsBigint } from "@utils/json";
import { bytesToBase64 } from "@utils/base64";
import { handlePageView } from "@/components/analytic/gaAnalyticCore";

export async function initGaAnalytic(element: Element): Promise<void> {
  await handlePageView(element.getAttribute("data-ga-analytic"));
}

registerModule("[data-ga-analytic]", (e) => initGaAnalytic(e));

/**
 * Replaces the current browser URL in the history while retaining the state
 * and encodes relevant metadata for page navigation.
 */
export const replaceUrl = (url: URL, content: { ci: bigint; ct: "CHANNEL" } | { ci: bigint; ct: "SUMMARY" }): void => {
  const metaInfo = {
    ci: content.ci,
    ct: content.ct,
    orr: url.pathname + url.search,
    p: url.pathname.replace(/^\/[a-z]{2}\//, "/"),
    r: window.location.href,
  };
  const encodedMetaInfo = bytesToBase64(new TextEncoder().encode(renderJsonWithNumbersAsBigint(metaInfo)));
  history.replaceState(metaInfo, "", url);
  void handlePageView(encodedMetaInfo);
};
